module.exports = __webpack_public_path__ + "img/face-flushed.8c6fda68.svg";